export const externalLoanCardSx = {
  borderRadius: 3,
  boxShadow: 3,
  bgcolor: 'background.paper',
};

export const externalLoanInteractiveCardSx = {
  ...externalLoanCardSx,
  transition: 'all .25s ease',
  '@media (hover: hover)': {
    '&:hover': {
      boxShadow: 6,
      transform: 'translateY(-3px)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': {
      transform: 'none',
    },
  },
};

export const externalLoanNestedCardSx = {
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'grey.50',
};

export const externalLoanButtonSx = {
  transition: 'background-color .2s ease, border-color .2s ease, color .2s ease',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
};
